module.exports = "<fuse-main></fuse-main>\n"


//////////////////
// WEBPACK FOOTER
// /usr/app/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main